import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";

export const AdminMenuItems = [
  // {
  //   name: "تنظیمات",
  //   route: "/setting",
  //   isActive: "setting",
  //   icon: SettingsApplicationsIcon,
  // },
  {
    name: "منتظر تایید",
    route: "/waiting-list",
    isActive: "waiting-list",
    icon: AccessTimeIcon,
  },
  {
    name: "تایید شده",
    route: "/confirmed-list",
    isActive: "confirmed-list",
    icon: ThumbUpOffAltIcon,
  },
  {
    name: "رد شده",
    route: "/failed-list",
    isActive: "failed-list",
    icon: ThumbDownOffAltIcon,
  },
];
